require("slick-carousel");

const initUserStoriesSlider = () => {
  const $userStoriesList = $(".js-their-story-list");

  if (!$userStoriesList.length) return;

  $userStoriesList.slick({
    infinite: true,
    speed: 350,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    prevArrow: $(".js-their-story-prev-btn"),
    nextArrow: $(".js-their-story-next-btn"),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          variableWidth: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        },
      },
    ],
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initUserStoriesSlider();
});
